import React from "react";
import BulkUploadFile from "../../components/BulkUploadFile";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as SlotsPropertiesActions from "../../store/actions/Slots";

const instructions = [
  "Gig Cancellation Fee On Slot level will be exempted",
  "Gig Cancellation Fee if exist for the given slot capacity and driver, then it will be reverted",
  "Gig Cancellation Fee will be zero if rider tries to cancel it",
  "Please provide data as per the format in the sample file.",
  "Please try to open your sample csv file always with MS excel or google sheets but don't open with other editors.",
];

const SlotsCancellationFeeExemption = ({
  getSlotsCancellationFeeExemptionUrl,
}) => {
  return (
    <BulkUploadFile
      instructions={instructions}
      btnDataTestID="slotsCancellationFeeExemption"
      uploadUrl="/driver-shift/slot/bulk-slot-cancellation-fee-exempted/ack"
      sampleURL="/sample/bulk_slot_cancellation_fee_exempted.csv"
      id="slotsCancellationFeeExemptionModal"
      sendExtraAck={true}
      keyName="callback_key"
      heading="Gigs Cancellation Fee Exemption upload (Slots)"
      getUploadUrl={getSlotsCancellationFeeExemptionUrl}
    />
  );
};

function mapDispatchToProps(dispatch) {
  return {
    getSlotsCancellationFeeExemptionUrl: bindActionCreators(
      SlotsPropertiesActions.getSlotsCancellationFeeExemptionUrl,
      dispatch
    ),
  };
}

export default connect(null, mapDispatchToProps)(SlotsCancellationFeeExemption);
